<!--
 * @Author: dengyong simon.deng@wetax.com.cn
 * @Date: 2022-06-16 10:51:21
 * @LastEditors: yangyi
 * @LastEditTime: 2022-11-18 11:52:13
 * @FilePath: \tiangong2\src\views\sysmana\application\components\packConfig.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="pack-cont">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="渠道参数配置" name="paramConfig"> </el-tab-pane>
      <el-tab-pane label="渠道计费点配置" name="billingConfig"> </el-tab-pane>
      <el-tab-pane label="渠道发货回调地址" name="callbackUrlConfig"> </el-tab-pane>
    </el-tabs>
    <div v-if="activeName === 'paramConfig' || activeName === 'callbackUrlConfig'" class="channel-cont">
      <span>渠道</span>
      <el-select v-model="callbackUrlConfigForm.channelId" size="small" placeholder="请选择" @change="changeChannel">
        <el-option v-for="item in channelOptions" :key="item.channelId" :label="item.channelName" :value="item.channelId"> </el-option>
      </el-select>
    </div>
    <div v-if="activeName === 'billingConfig'">
      <div class="billing" v-for="(item, index) in billingConfigForm" :key="index">
        <span>编号</span>
        <el-input v-model="item.id" size="small"></el-input>
        <span>商品名</span>
        <el-input v-model="item.name" size="small"></el-input>
        <span>价格</span>
        <el-input v-model="item.price" size="small"></el-input>
        &nbsp;&nbsp; <el-button @click.prevent="removeBilling(item)" size="small">删除</el-button>
      </div>
      <div class="btns">
        <el-button @click="addBilling" size="small">添加新计费点</el-button>
      </div>
    </div>
    <div v-if="activeName === 'paramConfig'">
      <p class="title_label"><b>客户端参数</b></p>
      <ul class="params">
        <li v-for="(client, index) in paramConfig.clientConfigKeys" :key="index">
          <div class="params-cont">
            <span>{{ client.keyName }}</span>
            <el-input v-model="client.val" size="small" placeholder="请输入"></el-input>
          </div>
        </li>
      </ul>
      <p class="title_label"><b>服务端参数</b></p>
      <ul class="params">
        <li v-for="(server, index) in paramConfig.serverConfigKeys" :key="index">
          <div class="params-cont">
            <span>{{ server.keyName }}</span>
            <el-input v-model="server.val" size="small" placeholder="请输入"></el-input>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="activeName === 'callbackUrlConfig' && callbackUrlConfigForm.notifyUrl" class="channel-cont notifyUrl">
      <span>回调地址</span>
      <el-input v-model="callbackUrlConfigForm.notifyUrl" size="small" placeholder="请输入回调地址"></el-input>
    </div>
    <plugin ref="plugins" :fromPackData="fromPackData"></plugin>
    <packInfoConfig ref="packInfoConfigs" :fromPackData="fromPackData"></packInfoConfig>
  </div>
</template>
<script>
import plugin from './plugin'
import packInfoConfig from './packInfoConfig'
import { queryAllChannel, getChannelConfig } from '@/api/sysmana.model'
export default {
  name: 'packConfig',
  props: ['packData'],
  components: {
    plugin,
    packInfoConfig
  },
  data() {
    return {
      activeName: 'paramConfig',
      channelOptions: [],
      callbackUrlConfigForm: {
        channelId: '',
        notifyUrl: ''
      },
      paramConfig: {
        clientConfigKeys: [],
        serverConfigKeys: []
      },
      billingConfigForm: []
    }
  },
  watch: {
    packData() {
      this.getAllChannel()
      this.getGoodsConfig()
      this.query()
      this.activeName = 'paramConfig'
    }
  },
  computed: {
    fromPackData() {
      return this.packData
    }
  },
  created() {
    this.getAllChannel()
    this.getGoodsConfig()
    this.query()
  },
  methods: {
    query() {
      this.queryChannelConfig(this.packData.channelId)
      this.callbackUrlConfigForm.channelId = this.packData.channelId
    },
    getGoodsConfig() {
      this.billingConfigForm = []
      if (this.packData.goodsData) {
        const goodsData = JSON.parse(this.packData.goodsData)
        for (const k in goodsData) {
          this.billingConfigForm.push(goodsData[k])
        }
      } else {
        this.addBilling()
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event)
    },
    queryChannelConfig(channelId) {
      // 获取服务端客户端参数
      this.paramConfig.clientConfigKeys = []
      this.paramConfig.serverConfigKeys = []
      getChannelConfig({
        channelId: channelId
      }).then((data) => {
        const { clientConfigKeys, serverConfigKeys } = data
        if (this.packData.clientAppDataMap) {
          // 回显获取客户端参数
          for (const k in this.packData.clientAppDataMap) {
            clientConfigKeys.forEach((item) => {
              if (k === item.keyValue) {
                this.paramConfig.clientConfigKeys.push({
                  keyName: item.keyName,
                  keyName_1: item.keyValue,
                  val: this.packData.clientAppDataMap[k]
                })
              }
            })
          }
        } else {
          clientConfigKeys.map((item) => {
            this.paramConfig.clientConfigKeys.push({
              keyName: item.keyName,
              keyName_1: item.keyValue,
              val: ''
            })
          })
        }
        if (this.packData.appDataMap) {
          // 回显获取服务端参数
          for (const k in this.packData.appDataMap) {
            serverConfigKeys.forEach((item) => {
              if (k === item.keyValue) {
                this.paramConfig.serverConfigKeys.push({
                  keyName: item.keyName,
                  keyName_1: item.keyValue,
                  val: this.packData.appDataMap[k]
                })
              }
            })
          }
        } else {
          serverConfigKeys.map((item) => {
            this.paramConfig.serverConfigKeys.push({
              keyName: item.keyName,
              keyName_1: item.keyValue,
              val: ''
            })
          })
        }
      })
    },
    getAllChannel() {
      // 获取渠道下拉信息
      queryAllChannel().then((data) => {
        if (data) {
          this.channelOptions = data
          data &&
            data.forEach((item) => {
              if (item.channelId === this.packData.channelId) {
                this.callbackUrlConfigForm.notifyUrl = item.notifyUrl
              }
            })
        }
      })
    },
    changeChannel(info) {
      this.channelOptions.forEach((item) => {
        if (info === item.channelId) {
          this.callbackUrlConfigForm.notifyUrl = item.notifyUrl
        }
      })
      this.paramConfig.clientConfigKeys = []
      this.paramConfig.serverConfigKeys = []
      getChannelConfig({
        channelId: info
      }).then((data) => {
        const { clientConfigKeys, serverConfigKeys } = data
        clientConfigKeys &&
          clientConfigKeys.map((item) => {
            this.paramConfig.clientConfigKeys.push({
              keyName: item.keyName,
              keyName_1: item.keyValue,
              val: ''
            })
          })
        serverConfigKeys &&
          serverConfigKeys.map((item) => {
            this.paramConfig.serverConfigKeys.push({
              keyName: item.keyName,
              keyName_1: item.keyValue,
              val: ''
            })
          })
      })
    },
    removeBilling(item) {
      const index = this.billingConfigForm.indexOf(item)
      if (index !== -1) {
        this.billingConfigForm.splice(index, 1)
      }
    },
    addBilling() {
      this.billingConfigForm.push({
        id: '',
        name: '',
        price: ''
      })
    },
    // 以下为提交参数
    submitClientConfigKeys() {
      // 客户端参数
      const submitClient = []
      this.paramConfig.clientConfigKeys.forEach((item) => {
        submitClient.push({
          keyName: item.keyName_1,
          keyValue: item.val
        })
      })
      return JSON.stringify(submitClient)
    },
    submitServerConfigKeys() {
      //  服务端参数
      const submitServer = []
      this.paramConfig.serverConfigKeys.forEach((item) => {
        submitServer.push({
          keyName: item.keyName_1,
          keyValue: item.val
        })
      })
      return JSON.stringify(submitServer)
    },
    submitGoodsConfig() {
      // 计费点配置
      const newGoodsConfig = {}
      this.billingConfigForm.forEach((item) => {
        const key = item.id
        newGoodsConfig[key] = item
      })
      return JSON.stringify(newGoodsConfig)
    },
    submitPluginConfigs() {
      // 插件配置
      const pluginConfig = {}
      const pluginInfo = this.$refs.plugins
      pluginInfo.pluginArr.forEach((item) => {
        const key = item.pluginId
        const valueArr = []
        item.configMapArr.forEach((ite) => {
          valueArr.push({
            keyName: ite.keyName,
            keyValue: ite.val
          })
        })
        pluginConfig[key] = valueArr
      })
      return JSON.stringify(pluginConfig)
    },
    submitPackInfo() {
      // 包体基础信息配置
      const packInfo = this.$refs.packInfoConfigs
      const { id, devGameId, appName, clientGameName, packageName, splashPath, iconPath, replaceResourceList } = packInfo.packInfoConfig
      const packInfoObj = {
        id: id + '',
        devGameId: devGameId + '',
        gameName: appName,
        clientGameName,
        packageName,
        channelId: this.callbackUrlConfigForm.channelId + '',
        splashPath: this.fromPackData.splashPath,
        iconPath: this.fromPackData.iconPath,
        newSplashPath: splashPath.split('tmp/')[1],
        newIconPath: iconPath.split('tmp/')[1]
      }
      const resourceObj = []
      replaceResourceList.forEach((item) => {
        resourceObj.push({
          resourceTmpId: item.resourceTmpId + '',
          replaceResourceUrl: item.imgUrl.includes('tmp/') ? item.imgUrl.split('tmp/')[1] : item.replaceResourceUrl
        })
      })
      packInfoObj.replaceResources = JSON.stringify(resourceObj)
      return packInfoObj
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.el-input) {
  width: 300px;
}
:deep(.el-form-item) {
  margin-bottom: 15px;
}
p.title_label {
  padding-left: 30px;
  line-height: 30px;
  font-size: 16px;
}
.params {
  padding-left: 20px;
  li {
    display: flex;
    margin-bottom: 10px;
    line-height: 30px;
    .params-cont {
      flex: 1;
      span {
        display: inline-block;
        width: 140px;
        padding-right: 10px;
        text-align: right;
      }
    }
  }
}
.billing {
  padding-left: 50px;
  margin-bottom: 10px;
  :deep(.el-input) {
    width: 120px;
    margin: 0 10px;
  }
}

.channel-cont {
  padding-left: 20px;
  padding-bottom: 10px;
  span {
    display: inline-block;
    width: 67px;
    padding-right: 10px;
    text-align: right;
  }
}
.notifyUrl {
  margin: 10px 0;
}
.btns {
  margin-bottom: 20px;
  padding-bottom: 20px;
  text-align: center;
  border-bottom: 1px solid #f2f2f2;
}
</style>
